module.exports = __webpack_public_path__ + "img/static__image.684eca11.png";